import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './config';

// 加载全部命名空间：common / home / products / applications / company / blog

import enCommon from './locales/en/common.json';
import enHome from './locales/en/home.json';
import enProducts from './locales/en/products.json';
import enApplications from './locales/en/applications.json';
import enCompany from './locales/en/company.json';
import enBlog from './locales/en/blog.json';

import zhCommon from './locales/zh/common.json';
import zhHome from './locales/zh/home.json';
import zhProducts from './locales/zh/products.json';
import zhApplications from './locales/zh/applications.json';
import zhCompany from './locales/zh/company.json';
import zhBlog from './locales/zh/blog.json';

import hiCommon from './locales/hi/common.json';
import hiHome from './locales/hi/home.json';
import hiProducts from './locales/hi/products.json';
import hiApplications from './locales/hi/applications.json';
import hiCompany from './locales/hi/company.json';
import hiBlog from './locales/hi/blog.json';

import deCommon from './locales/de/common.json';
import deHome from './locales/de/home.json';
import deProducts from './locales/de/products.json';
import deApplications from './locales/de/applications.json';
import deCompany from './locales/de/company.json';
import deBlog from './locales/de/blog.json';

import esCommon from './locales/es/common.json';
import esHome from './locales/es/home.json';
import esProducts from './locales/es/products.json';
import esApplications from './locales/es/applications.json';
import esCompany from './locales/es/company.json';
import esBlog from './locales/es/blog.json';

import ruCommon from './locales/ru/common.json';
import ruHome from './locales/ru/home.json';
import ruProducts from './locales/ru/products.json';
import ruApplications from './locales/ru/applications.json';
import ruCompany from './locales/ru/company.json';
import ruBlog from './locales/ru/blog.json';

import jaCommon from './locales/ja/common.json';
import jaHome from './locales/ja/home.json';
import jaProducts from './locales/ja/products.json';
import jaApplications from './locales/ja/applications.json';
import jaCompany from './locales/ja/company.json';
import jaBlog from './locales/ja/blog.json';

import koCommon from './locales/ko/common.json';
import koHome from './locales/ko/home.json';
import koProducts from './locales/ko/products.json';
import koApplications from './locales/ko/applications.json';
import koCompany from './locales/ko/company.json';
import koBlog from './locales/ko/blog.json';

import arCommon from './locales/ar/common.json';
import arHome from './locales/ar/home.json';
import arProducts from './locales/ar/products.json';
import arApplications from './locales/ar/applications.json';
import arCompany from './locales/ar/company.json';
import arBlog from './locales/ar/blog.json';

import faCommon from './locales/fa/common.json';
import faHome from './locales/fa/home.json';
import faProducts from './locales/fa/products.json';
import faApplications from './locales/fa/applications.json';
import faCompany from './locales/fa/company.json';
import faBlog from './locales/fa/blog.json';

import ptCommon from './locales/pt/common.json';
import ptHome from './locales/pt/home.json';
import ptProducts from './locales/pt/products.json';
import ptApplications from './locales/pt/applications.json';
import ptCompany from './locales/pt/company.json';
import ptBlog from './locales/pt/blog.json';

import idCommon from './locales/id/common.json';
import idHome from './locales/id/home.json';
import idProducts from './locales/id/products.json';
import idApplications from './locales/id/applications.json';
import idCompany from './locales/id/company.json';
import idBlog from './locales/id/blog.json';

const NAMESPACES = ['common', 'home', 'products', 'applications', 'company', 'blog'];

function bundle(
  common: Record<string, unknown>,
  home: Record<string, unknown>,
  products: Record<string, unknown>,
  applications: Record<string, unknown>,
  company: Record<string, unknown>,
  blog: Record<string, unknown>
) {
  return { common, home, products, applications, company, blog };
}

export const resources = {
  en: bundle(enCommon, enHome, enProducts, enApplications, enCompany, enBlog),
  zh: bundle(zhCommon, zhHome, zhProducts, zhApplications, zhCompany, zhBlog),
  hi: bundle(hiCommon, hiHome, hiProducts, hiApplications, hiCompany, hiBlog),
  de: bundle(deCommon, deHome, deProducts, deApplications, deCompany, deBlog),
  es: bundle(esCommon, esHome, esProducts, esApplications, esCompany, esBlog),
  ru: bundle(ruCommon, ruHome, ruProducts, ruApplications, ruCompany, ruBlog),
  ja: bundle(jaCommon, jaHome, jaProducts, jaApplications, jaCompany, jaBlog),
  ko: bundle(koCommon, koHome, koProducts, koApplications, koCompany, koBlog),
  ar: bundle(arCommon, arHome, arProducts, arApplications, arCompany, arBlog),
  fa: bundle(faCommon, faHome, faProducts, faApplications, faCompany, faBlog),
  pt: bundle(ptCommon, ptHome, ptProducts, ptApplications, ptCompany, ptBlog),
  id: bundle(idCommon, idHome, idProducts, idApplications, idCompany, idBlog)
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES,
  ns: NAMESPACES,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  react: { useSuspense: false }
});

export default i18n;
